import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";
// import BMXServiceRadioButton from "../../../../../Components/Inputs/BMXServiceRadioButton/BMXServiceRadioButton";

import { show } from "redux-modal";
import { updateDashboardByName } from "../../../../../Utils/Sockets";
const EnforcementsFormStepOne = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [contractTypeSelect, setContractTypeSelect] = useState([]);
  const [contacts, setContacts] = useState([]);
  const { values, form } = props;
  const REGISTRY_NAME = "contact";

  const getSelectedContact = (contact) => {
    if (!contact) return null;
    return contacts.find(
      (el) => el.uuid === contact.value || el.uuid === contact.uuid
    );
  };

  const getData = async (searchTerm) => {
    if (searchTerm?.length > 0) {
      const data = GlobalAuthFetch({
        path: `/contact/findByName/${searchTerm}`,
      });
      const [contactListPayload] = await Promise.all([data]);
      const contactList = contactListPayload?.payload?.data?.map((contact) => {
        return {
          uuid: contact.uuid,
          value: `${contact.name}`,
          ...contact,
        };
      });

      if (contactList?.length > 0) {
        setContacts(contactList);
        return contactList;
      } else {
        setContacts([]);
        return [];
      }
      return [];
    }
  };

  useEffect(() => {
    // loadContacts();
    const fetchData = async () => {
      const {
        payload: {
          data: { dictionaryEntries },
        },
      } = await GlobalAuthFetch({ path: "/dictionary/contractType/fieldName" });
      setContractTypeSelect(dictionaryEntries);
    };
    fetchData();
  }, [dispatch]);

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:enforcements.enforcementsData")} />
      <Row>
        <Col xs={6}>
          <Field
            name="title"
            label={`${t("global:enforcements.title")}*`}
            component={BMXTextField}
            data-cy="title"
          />
        </Col>
      </Row>

      <Row>
        <Col xs={6}>
          <Field
            currentValues={values}
            className="contact"
            component={BMXAsynchronous}
            getOptionLabel={(option) => {
              if (option.name) return option.name;
              return option;
            }}
            label={`${t("global:enforcements.contact")}*`}
            name="contact"
            options={contacts}
            // disabled={update}
            getData={getData}
            data-cy="contact"
            disablePortal={true}
            onClose={() => {
              const { values } = form.getState();

              form.change("representative", null);
            }}
          />
        </Col>
        <Col xs={{ span: 6 }}>
          <Field
            data-cy="representative"
            beforeIcon="people"
            afterIcon="add"
            afterIconSize="18px"
            afterIconClick={() => {
              const contactUuid =
                values?.contact?.uuid || values?.contact?.value;
              const updateSingleRegistry = () =>
                updateDashboardByName(REGISTRY_NAME, contactUuid);
              dispatch(
                show("RepresentativesModal", {
                  loadData: async () => {
                    await getData(values?.contact?.name);
                  },
                  header: t("global:document.representativeAdd"),
                  updateSingleRegistry,
                  uuid: contactUuid,
                })
              );
            }}
            disabled={!values?.contact}
            component={BMXSelectField}
            values={getSelectedContact(values?.contact)?.representatives?.map(
              (el) => ({
                value: el.uuid,
                name: `${el.name || ""} ${el.lastname || ""}`,
              })
            )}
            label={`${t("global:enforcements.representative")}`}
            name="representative"
            renderValue={(el) => {
              return `${el.name || ""} ${el.lastname || ""}`;
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Field
            name="description"
            label={`${t("global:enforcements.description")}*`}
            component={BMXTextField}
            data-cy="description"
          />
        </Col>
      </Row>
    </div>
  );
};

export default EnforcementsFormStepOne;
